import React from "react";
import { Music, Disc3 } from "lucide-react";
import { bandData } from "../mock";

const News = () => {
  return (
    <section className="py-20 bg-black">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Latest News
          </h2>
          <div className="w-24 h-1 bg-[#8b5cf6] mx-auto" />
        </div>

        {/* News Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Album Announcement */}
          <div className="bg-gradient-to-br from-[#1a1a2e] to-[#222236] rounded-lg p-8 hover:transform hover:scale-105 transition-all">
            <div className="w-16 h-16 bg-[#ff6b35] rounded-full flex items-center justify-center mb-6">
              <Disc3 size={32} className="text-white" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">
              {bandData.news[0].title}
            </h3>
            <p className="text-white/80 leading-relaxed mb-4">
              {bandData.news[0].description}
            </p>
            <span className="inline-block bg-[#ff6b35]/20 text-[#ff6b35] px-4 py-2 rounded-full text-sm font-semibold">
              Coming 2026
            </span>
          </div>

          {/* Single Announcement */}
          <div className="bg-gradient-to-br from-[#1a1a2e] to-[#222236] rounded-lg p-8 hover:transform hover:scale-105 transition-all">
            <div className="w-16 h-16 bg-[#4a5aff] rounded-full flex items-center justify-center mb-6">
              <Music size={32} className="text-white" />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">
              {bandData.news[1].title}
            </h3>
            <p className="text-white/80 leading-relaxed mb-4">
              {bandData.news[1].description}
            </p>
            <span className="inline-block bg-[#4a5aff]/20 text-[#4a5aff] px-4 py-2 rounded-full text-sm font-semibold">
              Before Spring 2026
            </span>
          </div>
        </div>

        {/* Social Media CTA */}
        <div className="mt-12 text-center bg-[#1a1a2e] rounded-lg p-8">
          <h3 className="text-2xl font-bold text-white mb-4">
            Stay Updated!
          </h3>
          <p className="text-white/80 mb-6">
            Follow us on social media for the latest updates, behind-the-scenes content, and announcements.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={bandData.social.youtube}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#ff0000] hover:bg-[#cc0000] text-white px-8 py-3 rounded-full font-bold"
            >
              Subscribe on YouTube
            </a>
            <a
              href={bandData.social.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#1877f2] hover:bg-[#145dbf] text-white px-8 py-3 rounded-full font-bold"
            >
              Follow on Facebook
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default News;
